import script from "./816.vue?vue&type=script&setup=true&lang=js"
export * from "./816.vue?vue&type=script&setup=true&lang=js"

import "./816.vue?vue&type=style&index=0&id=5ebf61a4&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/qpyx-korea-gm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ebf61a4"]])

export default __exports__